import React from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import {
  FDAvatar,
  FDImage,
  FDStack, useFDBodyColor,
  FDHeadlineText,
} from '@facet-wealth/design';
import MetaControlField from 'Components/UI/Meta/MetaForm/Components/MetaControlField';
import useScrollTopOnMount from 'Hooks/useScrollTopOnMount';
import useEventTrackingLogEvent, { categories, eventSubTypes, eventTypes } from 'EventTracking/useEventTrackingLogEvent';
import { ProgressBar } from 'Views/FreemiumEntry/HasRelationship/Content/Templates/PicklistQuestion/ProgressBar';
import StepNavigationFooter from 'Packages/FacetDesign/Components/Experimental/StepNavigationFooter';
import fr from 'facet-rest';
import { dataAttrs } from 'Helpers/Testing';
import {
  useBuildCommonFQEventProperties,
} from 'Views/FreemiumEntry/HasRelationship/Content/Components/utils';
import { QuizWrapperLayout } from 'Views/FreemiumEntry/HasRelationship/Content/Components/QuizWrapperLayout';
import useMobileLayout from 'Hooks/useMobileLayout';


const Insight = () => {
  const { resource, onSubmit, saving } = useMetaLayoutContext();
  const { logStandardizedEvent } = useEventTrackingLogEvent();
  const { buildCommonFQEventProperties } = useBuildCommonFQEventProperties();
  const isMobile = useMobileLayout();

  useScrollTopOnMount();

  useFDBodyColor('calm');

  return (
    <QuizWrapperLayout>
      <FDStack direction={'column'} spacing={4} {...dataAttrs('insight-container')}>
        <ProgressBar />
        <FDStack direction={'column'} spacing={4}>
          <FDStack direction={'column'} spacing={2}>
            {resource.withRelationship(fr.relationships.avatar.name,
              (rel) => (
                <FDStack direction={'column'} alignItems={'center'} paddingY={2}>
                  <FDAvatar
                    src={rel.link('related').url()}
                    alt={rel.meta('altText') || ''}
                    size={rel.meta('avatarSize') || 'xl'}
                  />
                </FDStack>),
              () => null)}
            {resource.attr('title') && <FDHeadlineText value={resource.attr('title')} size={isMobile ? 'md' : 'lg'} align={'center'} />}
            <MetaControlField attr={'insightDescription'} />
            {resource.withRelationship(fr.relationships.image.name,
              (rel) => (
                <FDStack direction={'column'} paddingY={4}>
                  <FDImage
                    src={rel.link('related').url()}
                    alt={rel.meta('altText') || ''}
                    aspectRatio={rel.meta('aspectRatio')}
                  />
                </FDStack>),
              () => null)}
          </FDStack>
          {resource.meta().canPut() && <StepNavigationFooter
            onNext={(selection) => {
              logStandardizedEvent(categories.facetQuiz, eventTypes.insight, eventSubTypes.clickedCTA, {
                eventProperties: {
                  ...buildCommonFQEventProperties(resource),
                  insightId: resource.attr('insightId'),
                  insightReferenceName: resource.attr('insightReferenceName'),
                },
              });
              onSubmit(selection);
            }}
            isLoading={saving}
            label={resource.attr('primaryActionLabel') || 'Continue'}
          />}
        </FDStack>
      </FDStack>
    </QuizWrapperLayout>
  );
};

export { Insight };
